import { useCallback } from 'react';

import { ITournamentsRepository } from 'domain/repositories/ITournamentsRepository';
import { httpClient } from 'infrastructure/providers/common/httpClient';

import { TournamentRoutes } from './routes';

export const useTournamentsRepository: ITournamentsRepository = () => {
  const fetchTournaments: ReturnType<ITournamentsRepository>['fetchTournaments'] = useCallback(
    (locationId?: string) =>
      httpClient.get(TournamentRoutes.getTournaments(locationId)).then((response) => response.data),
    [],
  );

  return {
    fetchTournaments,
  };
};
